export default class descendantticket {
    public CustomerId = 0
    public InitialNote = null as any
    public TicketTypeId = 0
}